import React from "react"

import { Avatar as MuiAvatar } from "@mui/material"
import { styled } from "@mui/material/styles"
import T from "prop-types"

import defaultPicture from "./default-picture.png"
import { MuiIcon } from "../mui-icon"

const DefaultIcon = styled(MuiIcon.AccountCircle)({
  "&.MuiSvgIcon-root": {
    fontSize: "48px",
    marginLeft: "-4px",
    marginRight: "28px",
  },
})

export const Avatar = ({ alt = "Avatar", className, src }) => {
  const avatarSource = src || defaultPicture

  return src ? (
    <MuiAvatar className={className} {...{ alt, src: avatarSource }} />
  ) : (
    <DefaultIcon className={className} />
  )
}

Avatar.propTypes = {
  alt: T.string,
  className: T.string,
  src: T.string,
}
